import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { useHandleResizeError } from '../../utilities/handleResizeError.js';
import { getPaginationStyle } from './StationsPageTableSubComponentStyling.js';
import { useNavigate } from 'react-router';
import { getPlatform, useScreenOrientation } from "../../utilities/orientationAndPlatform.js";
import { useTheme } from '@mui/material/styles';

export default function StationsPageTableBasic({columnHeaders, shownRows}) {
  const theme = useTheme();
  const navigate = useNavigate();

  useHandleResizeError();
  const paginationStyle = getPaginationStyle();
  const orientation = useScreenOrientation();
  const platform = getPlatform();

  let tableWidth = "";
  let headersLeftMargin = "0px";
  let headersRightMargin = "0px";

  if (platform === "mobile") {
    tableWidth = "100%";
    if (orientation === 0) {
      headersLeftMargin = '15%';
      headersRightMargin = '-7.5%';
    }
  } else if (platform === "desktop") {
    tableWidth = "98%";
  }

    return (
      <>
        {/* MUI Table */}
        <Box sx={{ width: tableWidth }} id="StationsPageTableBoxBasic">
          <DataGrid
            rows={shownRows}
            onRowClick={({ id }) => navigate(`/channelpage/${id}`)}
            getRowId={(row) => row.channel_id}
            columns={columnHeaders}
            disableColumnSorting={true}
            getEstimatedRowHeight={() => 66}
            sx={{
              backgroundColor: 'TableCell.background',
              border: 'none',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              '& .MuiDataGrid-columnHeaderTitleContainerContent': {
                overflow: 'visible',
                marginLeft: headersLeftMargin,
                marginRight: headersRightMargin,
              },
              '& .MuiDataGrid-scrollbar': {
                overflow: "hidden",
              },
              '& .MuiDataGrid-cell': {
                padding: '0px',
                borderBottom: theme.palette.TableCell.border,
                borderLeft: theme.palette.TableCell.borderLeft,
                borderRight: '0px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
              },
              '& .MuiDataGrid-cellEmpty': {
                borderLeft: '0px !important',
              },
              '& .MuiDataGrid-scrollbarFiller': {
                borderLeft: '0px !important',
                borderBottom: theme.palette.TableCell.borderLeft,
              },
              '& .MuiDataGrid-columnHeaders': {
                display: 'none',
              },
              '& .MuiDataGrid-row:hover': {
                cursor: 'pointer',
                backgroundColor: 'TableCell.hover',
              },
              '& .MuiDataGrid-footerContainer': {
                border: 'none',
              },
            }}
            slotProps={{ pagination: { sx: paginationStyle } }}
            hideFooterSelectedRowCount={true}
            disableColumnResize={true}
            disableColumnMenu={true}
            initialState={{ pagination: { paginationModel: { page: 0, pageSize: 15 } } }}
            pageSizeOptions={[15, 25, 50, 100, { value: -1, label: 'All' }]}
            localeText={{noRowsLabel: ""}}
          />
        </Box>
      </>
    );
}